// extracted by mini-css-extract-plugin
export default {"suggestions":"SuggestionsArticles_suggestions__uPuGY","cards":"SuggestionsArticles_cards__tPiNd","link":"SuggestionsArticles_link__e2qgC"};